import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getUserLoginPreconditions, saveUserLoginPreconditions} from 'src/openapi/admin/apis/UserLoginPreconditionsApi';
import {useAppDispatch} from 'src/store/hooks';

import type {SaveOptions} from 'src/components/save-with-reason/save-with-reason-button';
import type {UserLoginStateResponse} from 'src/openapi/admin/models/UserLoginStateResponse';

type Props = {
    userId: number,
};

export const useUserLoginPreconditions = ({userId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getUserLoginPreconditions({userId}),
    ), [apiDispatch, userId]);

    const saveDispatchAction = useCallback((
        userLoginStateSaveRequest: UserLoginStateResponse,
        signal: AbortSignal,
        options?: SaveOptions,
    ) => apiDispatch(
        saveUserLoginPreconditions({
            userId,
            userLoginStateSaveRequest: {...userLoginStateSaveRequest, reason: options?.reason},
        }, {signal}),
    ), [apiDispatch, userId]);

    return useCommonDataHook({
        getDispatchAction,
        saveDispatchAction,
        initValue: {
            mustChangePassword: false,
            showPasswordSharingWarning: false,
            ssoMandatory: true,
            ssoEnabled: true,
        },
    });
};
